import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { DataServiceService } from '../services/data-service.service';

export const authGuard: CanActivateFn = (route, state) => {
const sharedData=inject(DataServiceService);
const  authService=inject(AuthService)
const router=inject(Router)
sharedData.isauth$.subscribe((data)=>{

});
  if(authService.isAuthenticatedUser()){ 
    return true;
  }
  router.navigate(['/login']);
  return false;
};
